import React from 'react';
import sprintf from 'sprintf';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMAutoCompleteRow from 'components/search/SMAutoCompleteRow';
import SMHomeHostMainBannerView from './SMHomeHostMainBannerView';
import SMMapHelper from 'components/helpers/SMMapHelper';

class SMStayHomeView extends React.Component {

  constructor(props) {
    super(props);

    const queries = {
      location: null,
      price_type: 'stay',
      event_type: 'stay',
      stay_checkin_at: null,
      stay_checkout_at: null,
    };

    this.state = {
      currentQueries: queries,
      location: this.props.location,
      geocode: this.props.geocode,
      keyword: this.props.keyword,
      autoCompleteIsOpen: false,
      historyItems: [],
      autoCompleteItems: [],
      autoCompleteSelectedRow : 0,
      favoriteItems: [],
      browseHistoryItems: [],
    };
    this.campaignIndex = Math.floor( Math.random() * 5 );
  }

  componentDidMount() {
    this.autocomplete = new google.maps.places.AutocompleteService();
    this.$slider = $(this.refs.slider).flexslider({
      animation: "fade",
      animationSpeed: 2000,
      slideshowSpeed: 14000,
      controlNav: false,
      directionNav: false,
      animationLoop: true,
      slideshow: true,
      touch: false,
    });
    SMTrackHelper.criteoHome(this.props.currentUser ? this.props.currentUser.email : "");

    $(this.refs.checkInDatePicker).datepicker({
      minDate: 0,
      dateFormat:"yy/mm/dd",
      onClose: (text)=>{
        let currentQueries = this.state.currentQueries;
        const time = this.state.stayCheckinTime || "00:00";
        currentQueries.stay_checkin_at = SMFormatHelper.searchRangeDateTime(text, time);
        this.setState({
          stayCheckinDate: text,
          stayCheckinTime: time,
          currentQueries: currentQueries
        });
      }
    });

    $(this.refs.checkOutDatePicker).datepicker({
      dateFormat:"yy/mm/dd",
      onClose: (text)=>{
        let currentQueries = this.state.currentQueries;
        const time = this.state.stayCheckoutTime || "00:00";
        currentQueries.stay_checkout_at = SMFormatHelper.searchRangeDateTime(text, time);
        this.setState({
          stayCheckoutDate: text,
          stayCheckoutTime: time,
          currentQueries: currentQueries
      });
    }});
  }

  componentWillUnmount() {
  }

  // SMAutoCompleteRow delegate
  autoCompleteDidHide() {
    this.setState({autoCompleteIsOpen: false});
  }

  autoCompleteDidChangeRow(row){
    this.setState({autoCompleteSelectedRow: row});
  }

  locationDidStartEditing(e) {
    this.setState({autoCompleteIsOpen: true});
  }

  locationDidEndEditing(e) {
  }

  formDidSubmit(e) {
    e.preventDefault();
    window.location.href = Routes.search_index_path(this.state.currentQueries);
  }

  locationDidChangeValue(e) {
    const query = e.currentTarget.value;
    if (!query) {
      this.setState({autoCompleteItems: [], autoCompleteIsOpen: false});
      return;
    }
    this.autocomplete.getPlacePredictions({input: query}, (predictions, status) => {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
        let autoCompleteItems = [];
        predictions = SMMapHelper.sortPredictions(predictions);
        predictions.forEach(function(prediction) {
          autoCompleteItems.push(prediction);
        });
        this.setState({
          autoCompleteItems: autoCompleteItems,
          autoCompleteIsOpen: true,
        });
      } else {
        this.setState({
          autoCompleteItems: [],
          autoCompleteIsOpen: false,
        });
      }
    });
  }

  autoCompleteItemDidSelect(i){
    const item = this.state.autoCompleteItems[i];
    const googlePlacesService = new google.maps.places.PlacesService(this.refs.locationField);
    googlePlacesService.getDetails({placeId:item.place_id}, (details, status)=>{
      const displayText = item.terms[0].value;
      let state = {
        autoCompleteIsOpen: false,
        geocode: null,
      };
      if(details){
        const l = details.geometry.location;
        const vp = details.geometry.viewport;
        const radius = SMMapHelper.getRadiusByViewport(vp);
        state.geocode = SMMapHelper.getGeocode(l.lat(), l.lng(), radius);
        this.refs.locationField.value = displayText;
      }
      this.setState(state);
      $(this.refs.locationField).blur();
    });
  }

  renderRoomFeatureItem(room, shouldSuffix) {
    let className = "top-units__image";
    if (shouldSuffix) className += " top-units__image-col__w6";

    return (
      <a href={Routes.space_room_path(room.space.username, room.uid)} className="a__top-units">
        <div className="top-units">
          <div className={className}>
            <img src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490})} alt={sprintf("%s の写真", SMFormatHelper.roomName(room))} className="top-units__image-pict" />
            {/*<img data-src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490})} alt={sprintf("%s の写真", SMFormatHelper.roomName(room))} className="top-units__image-pict cld-hidpi" />*/}
            {SMFormatHelper.renderRoomPriceText(room, 'default', {price_type: 'stay'})}
          </div>
          <div className="top-units__body">
            <div className="top-units__body-inner link__subcolor">
              <h3 className="top-units__body-title">{SMFormatHelper.roomName(room)}</h3>
            </div>
            <p className="top-units__body-access">{room.space.access}</p>
          </div>
        </div>
      </a>
    );
  }

  renderRoomFeatures() {
    let rows = [];
    let row = 0;
    let colItems = [];
    this.props.roomFeatures.forEach((feature, index) => {

      const room = feature.item;
      const col = index % 3;

      if (row % 2 == 0) {
        if (col == 0) {
          rows.push(<div key={index} className="col-sm-12 col-md-6">{this.renderRoomFeatureItem(room, true)}</div>);
        }
        else if (col == 1) {
          colItems = [];
          colItems.push(<div key={index} className="col-sm-12 col-md-6">{this.renderRoomFeatureItem(room, false)}</div>);
        }
        else if (col == 2) {
          colItems.push(<div key={index} className="col-sm-12 col-md-6">{this.renderRoomFeatureItem(room, false)}</div>);
          rows.push(<div key={index} className="col-sm-12 col-md-6"><div className="row">{colItems}</div></div>);
        }
      }
      if (row % 2 == 1) {
        if (col == 0) {
          colItems = [];
          colItems.push(<div key={index} className="col-sm-12 col-md-6">{this.renderRoomFeatureItem(room, false)}</div>);
        }
        else if (col == 1) {
          colItems.push(<div key={index} className="col-sm-12 col-md-6">{this.renderRoomFeatureItem(room, false)}</div>);
          rows.push(<div key={index} className="col-sm-12 col-md-6"><div className="row">{colItems}</div></div>);
        }
        else if (col == 2) {
          rows.push(<div key={index} className="col-sm-12 col-md-6">{this.renderRoomFeatureItem(room, true)}</div>);
        }
      }

      if (col %3 == 2) {
        row++;
      }
    });
    return(
      <div className="page__odd page__padding">
        <div className="container">
          <h2 className="top-title">注目の民泊物件・宿泊施設</h2>
          <div className="row">
            {rows}
          </div>
        </div>
      </div>
    );
  }

  renderLatest() {
    let rows = [];
    this.props.latestRooms.forEach((room, index)=>{
      rows.push(
        <div key={index} className="col-sm-12 col-md-3">
          <a href={Routes.space_room_path(room.space.username, room.uid)} className="a__top-units">
            <div className="top-units">
              <div className="top-units__image">
                <img src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490})} alt={sprintf("%s の写真", SMFormatHelper.roomName(room))} className="top-units__image-pict" />
                {/*<img data-src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490})} alt={sprintf("%s の写真", SMFormatHelper.roomName(room))} className="top-units__image-pict cld-hidpi" />*/}
                {SMFormatHelper.renderRoomPriceText(room, 'default', {price_type: 'stay'})}
              </div>
              <div className="top-units__body">
                <div className="top-units__body-inner link__subcolor">
                  <h3 className="top-units__body-title">{SMFormatHelper.roomName(room)}</h3>
                </div>
                <p className="top-units__body-access">{room.space.access}</p>
              </div>
            </div>
          </a>
        </div>
      );
    });
    return(
      <div className="page__odd page__padding">
        <div className="container">
          <h2 className="top-title">新着の民泊物件・宿泊施設</h2>
          <div className="row">
            {rows}
          </div>
          <div className="mod-more__area">
            <a href={Routes.search_index_path({price_type: 'stay', sort:"created"})} className="button-blue mod-more__area-button">新着の民泊物件・宿泊施設をもっと見る</a>
          </div>
        </div>
      </div>
    );
  }

  renderTopSearch() {
    return(
      <div className="top-search top-search__stay">
        <form ref="searchForm" onSubmit={this.formDidSubmit.bind(this)} action={Routes.search_index_path()}>
          <div className="top-search__box">
            <input ref="locationField"
              name="location"
              type="text"
              maxLength="2048"
              aria-haspopup="false"
              aria-autocomplete="both"
              spellCheck="false"
              autoComplete="off"
              onFocus={this.locationDidStartEditing.bind(this)}
              onBlur={this.locationDidEndEditing.bind(this)}
              onChange={this.locationDidChangeValue.bind(this)}
              className="top-search__form-area"
              placeholder="エリアを入力してください" />
            <input
              name="stay_checkin_at"
              ref="checkInDatePicker"
              type="text"
              defaultValue={this.state.stayCheckinDate}
              data-date-type="start"
              className="js-datepicker datepicker top-search__form-period"
              placeholder="ご利用開始日（チェックイン）"
              readOnly={true} />
            <input
              name="stay_checkout_at"
              ref="checkOutDatePicker"
              type="text"
              defaultValue={this.state.stayCheckoutDate}
              data-date-type="end"
              className="js-datepicker datepicker top-search__form-period"
              placeholder="ご利用終了日（チェックアウト）"
              readOnly={true} />
            <input className="top-search__form-button" type="submit" value="&#xf002;" />
            <SMAutoCompleteRow
              isOpen={this.state.autoCompleteIsOpen}
              items={this.state.autoCompleteItems}
              selectedRow={this.state.autoCompleteSelectedRow}
              isTop={true}
              delegate={this}
               />
          </div>
        </form>
      </div>
    );
  }

  renderSlideImages() {
    let slideImages = [];
    const imageSize = SMAppHelper.isMobile() ? {width: 490, height: 490} : {width: 1200, height: 670};
    this.props.slides.forEach((slide, index)=>{
      const room = slide.item;
      const space = room.space;
      slideImages.push(
        <li key={index}>
          <img src={SMFormatHelper.roomImageURL(room, imageSize)} alt={SMFormatHelper.roomName(room)} />
          {/*<img data-src={SMFormatHelper.roomImageURL(room, imageSize)} alt={SMFormatHelper.roomName(room)} className="cld-hidpi" />*/}
          <div className="top-slider__caption">
            <p>
              <a href={Routes.space_room_path(room.space.username, room.uid)}>
                <span className="top-slider__caption-space">{SMFormatHelper.spaceName(space)}</span>
                <span className="top-slider__caption-category">{space.space_type_text} - {SMFormatHelper.renderRoomPriceText(room, 'slider', {price_type: 'stay'})}</span>
              </a>
            </p>
          </div>
        </li>
      );
    });
    return(
      <div id="slider" className="flexslider">
        <div ref="slider" className="top-slider__cover">
          <ul className="slides">
            {slideImages}
          </ul>
        </div>
        <div className="container top-slider__position">
          <div className="top-slider__title">
            <h2 className="top-slider__title-main">今度はここに 泊まってみよう</h2>
            <h1 className="top-slider__title-sub">田舎から都会までユニークな民泊・宿泊を簡単予約</h1>
          </div>
          <div className="top-slider__link">
            <p><a href={Routes.how_it_works_about_index_path()} className="top-slider__link-button">ご利用の流れ</a></p>
          </div>
          {this.renderTopSearch()}
        </div>
      </div>
    );
  }

  renderPopularItem(room, rank) {
    let rankClassName = sprintf(
      "units-ranking__no%s units-ranking units-ranking__icon",
      rank < 3 ? rank + 1 : "n"
    );
    let heightClassName = sprintf("top-units__image top-units__image-col__h%s", rank == 0 ? 6 : 3);
    return (
      <a href={Routes.space_room_path(room.space.username, room.uid)} className="a__top-units">
        <div className="top-units">
          <div className={heightClassName}>
            <div className={rankClassName}>
              <div className="units-ranking__icon-body">
                <span className="units-ranking__icon-number">{rank + 1}</span>
              </div>
            </div>
            <img src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490})} alt={sprintf("%s の写真", SMFormatHelper.roomName(room))} className="top-units__image-pict" />
            {/*<img data-src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490})} alt={sprintf("%s の写真", SMFormatHelper.roomName(room))} className="top-units__image-pict cld-hidpi" />*/}
            {SMFormatHelper.renderRoomPriceText(room, 'default', {price_type: 'stay'})}
          </div>
          <div className="top-units__body">
            <div className="top-units__body-inner link__subcolor">
              <h3 className="top-units__body-title">{SMFormatHelper.roomName(room)}</h3>
            </div>
            <p className="top-units__body-access">{room.space.access}</p>
          </div>
        </div>
      </a>
    );
  }

  renderPopularRooms() {
    const popularRoom = this.props.popularRooms[0];

    let rows = [];
    for (var i = 1; i < 5; i++) {
      const room = this.props.popularRooms[i];
      rows.push(
        <div key={i} className="col-sm-12 col-md-6">
          {this.renderPopularItem(room, i)}
        </div>
      );
    }
    return (
      <div className="page__even page__padding">
        <div className="container">
          <h2 className="top-title">人気の民泊物件・宿泊施設</h2>
          <div className="row">
            <div className="col-sm-12 col-md-6">
              {this.renderPopularItem(popularRoom, 0)}
            </div>
            <div className="col-sm-12 col-md-6">
              <div className="row">
                {rows}
              </div>
            </div>
          </div>
          <div className="mod-more__area">
            <a href={Routes.stay_ranking_index_path()} className="button-blue mod-more__area-button">人気の民泊物件・宿泊施設をもっと見る</a>
          </div>
        </div>
      </div>
    );
  }

  renderTutorials() {

    let signUp = this.props.currentUser ? null : (
      <div className="mod-more__area top-flow__regist">
        <h2 className="top-flow__regist-title">{I18n.t('service.label_000059')}</h2>
        <a href={Routes.new_user_registration_path()} className="button-blue mod-more__area-button top-flow__regist-button">{I18n.t('service.label_000060')}</a>
      </div>
    );

    return (
      <div className="page__even page__padding-mb0">
        <div className="container">
          <h2 className="top-title">民泊物件・宿泊施設の貸し借りを簡単に</h2>
          <div className="row top-flow">
            <div className="col-xs-6 col-md-3">
              <div className="top-flow__step-1 top-flow__step">
                <h3 className="top-flow__step-title">スペースを探す</h3>
                <p>エリアや目的などから<br />民泊物件・宿泊施設を探します。</p>
              </div>
            </div>
            <div className="col-xs-6 col-md-3">
              <div className="top-flow__step-2 top-flow__step">
                <h3 className="top-flow__step-title">予約リクエスト</h3>
                <p>予約したい日程を選んで<br />ホストとやりとり。</p>
              </div>
            </div>
            <div className="col-xs-6 col-md-3">
              <div className="top-flow__step-3 top-flow__step">
                <h3 className="top-flow__step-title">予約可否</h3>
                <p>ホストが<br />利用を承認すれば予約成立。</p>
              </div>
            </div>
            <div className="col-xs-6 col-md-3">
              <div className="top-flow__step-4 top-flow__step">
                <h3 className="top-flow__step-title">決済・利用</h3>
                <p>決済までワンストップで。<br />民泊物件・宿泊施設を利用。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSearchCategory() {
    let rows = [];
    this.props.popularFeatures.forEach((popularFeature, index) => {
      const feature = popularFeature.item;
      if (feature.items.length > 0) {
        rows.push(
          <div key={index} className="col-sm-12 col-md-4">
            <div className="top-category__image">
              <a key={feature.id} href={sprintf('/areas/%s/price_type/stay', feature.search_queries.location)}>
                <img src={SMFormatHelper.imageURLWithTransform(feature.items[0].item.thumbnails[0].image)} className="top-category__image-pict" />
                {/*<img data-src={SMFormatHelper.imageURLWithTransform(feature.items[0].item.thumbnails[0].image)} className="top-category__image-pict cld-hidpi" />*/}
                <div className="top-category__image-bg">
                  <h3 className="top-category__title">{feature.title}</h3>
                </div>
              </a>
            </div>
          </div>
        );
      }
    });

    if (rows.length > 0) {
      return (
        <div className="page__odd page__padding-mb0">
          <div className="container">
            <h2 className="top-title">人気のエリア</h2>
            <div className="row top-category">
              {rows}
            </div>
          </div>
        </div>
      );
    }
  }

  renderBrandingIcons() {
    return (
      <div className="top-page__appeal page__padding">
        <div className="container">
          <h3 className="top-appeal__title">{I18n.t('service.label_000053')}</h3>
            <ul className="top-appeal__list clearfix">
              <li><a href="http://spacemarket.co.jp/archives/5331" target="_blank"><img src={SMRailsBridge.assetPath.mediaNHK} alt="NHK" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/5381" target="_blank"><img src={SMRailsBridge.assetPath.mediaNikkei} alt="日経新聞" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/6061" target="_blank"><img src={SMRailsBridge.assetPath.mediaFujiTV} alt="フジテレビ" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/5621" target="_blank"><img src={SMRailsBridge.assetPath.mediaTBS} alt="TBS" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/5621" target="_blank"><img src={SMRailsBridge.assetPath.mediaAsahi} alt="朝日新聞" /></a></li>
              <li><a href="http://diamond.jp/articles/-/60963" target="_blank"><img src={SMRailsBridge.assetPath.mediaYahoo} alt="ヤフーニュース" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/5471" target="_blank"><img src={SMRailsBridge.assetPath.mediaYomiuri} alt="読売新聞" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/721" target="_blank"><img src={SMRailsBridge.assetPath.mediaJwave} alt="JWAVE" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/7261" target="_blank"><img src={SMRailsBridge.assetPath.mediaReuters} alt="ロイター" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/7351" target="_blank"><img src={SMRailsBridge.assetPath.mediaR25} alt="R25" /></a></li>
            </ul>
          <h3 className="top-appeal__title clearfix">{I18n.t('service.label_000054')}</h3>
            <ul className="top-appeal__list">
              <li><img src={SMRailsBridge.assetPath.companyTechInAsia} alt="TechInAsia" /></li>
              <li><img src={SMRailsBridge.assetPath.companyBase} alt="Base" /></li>
              <li><img src={SMRailsBridge.assetPath.companyCa} alt="CyberAgent" /></li>
              <li><img src={SMRailsBridge.assetPath.companyCrazy} alt="Crazy" /></li>
              <li><img src={SMRailsBridge.assetPath.companyKaizen} alt="Kaizen Platform" /></li>
              <li><img src={SMRailsBridge.assetPath.companyYjfx} alt="YJFX" /></li>
              <li><img src={SMRailsBridge.assetPath.companyTracos} alt="TransCosmos" /></li>
              <li><img src={SMRailsBridge.assetPath.companyWantedly} alt="Wantedly" /></li>
              <li><img src={SMRailsBridge.assetPath.companyLe} alt="Link Event Produce" /></li>
            </ul>
        </div>
      </div>
    );
  }

  renderSignUp() {
    return (
      <div className="mod-banner mod-banner__guest">
        <div className="container">
          <h3>{I18n.t('service.label_000059')}</h3>
          <p>{I18n.t('service.label_000061')}</p>
          <a href={Routes.new_user_registration_path()} className="mod-banner__button">{I18n.t('service.label_000060')}</a>
        </div>
      </div>
    );
  }

  render() {

    if (this.props.currentUser) {
      return(
        <div className="site-main">
          {this.renderSlideImages()}
          {this.renderTutorials()}
          {this.renderRoomFeatures()}
          <SMHomeHostMainBannerView />
          {this.renderPopularRooms()}
          {/* {this.renderSearchCategory()} */}
          {this.renderLatest()}
          {this.renderBrandingIcons()}
        </div>
      );

    } else {
      return(
        <div className="site-main">
          {this.renderSlideImages()}
          {this.renderTutorials()}
          {this.renderRoomFeatures()}
          <SMHomeHostMainBannerView />
          {this.renderPopularRooms()}
          {/* {this.renderSearchCategory()} */}
          {this.renderLatest()}
          {this.renderSignUp()}
          {this.renderBrandingIcons()}
        </div>
      );
    }
  }
}
export default SMStayHomeView;



// WEBPACK FOOTER //
// ./app/javascript/components/home/SMStayHomeView.jsx